import React from "react";

// Light theme colors (default)
const lightColors = {
  containerPrimarySolidHigh: "#8C76FF",
  hoverBackground: "rgba(2, 2, 16, 0.06)",
  shimmer: "#02021009",
  shimmerLight: "#FFFFFF40",
  accentColor: "#5b3df6",
  accentColorDisabled: "rgba(102, 73, 255, 0.1)",
  secondAccentColor: "#FAFFE2",
  chatRightAccentColor: "#49ffc1",
  chatLeftAccentColor: "#ff4987",
  backDropColor: "#0007",
  colorErrorDefault: "rgba(220, 54, 46, 1)",
  containerNeutralLightLow: "rgba(2, 2, 16, 0.1)",
  containerNeutralSolidSurface: "#FFF", // #E7E7E9 MUST BE HEX FOR COLOR EXTRACTION! "rgba(231, 231, 233, 1)",
  containerNeutralLightLowest: "rgba(2, 2, 16, 0.05)",
  containerNeutralSolidSurfaceInverted: "rgba(21, 21, 23, 1)",
  containerNeutralSolidMediumLow: "#CBCBCE",
  containerNeutralLightMediumFixed: "#F4F4FAB2",
  containerNeutralLightMedium: "#02021052",
  containerNeutralSolidHigh: "rgba(144, 144, 150, 1)",
  containerNeutralTransparent: "rgba(231, 231, 233, 0)",
  containerNeutralHalfTransparent: "rgba(231, 231, 233, 0.6)",
  containerNeutralSolidLow: "#E7E7E9",
  containerNeutralSolidLowest: "#F3F3F4",
  containerNeutralDarkMedium: "#F1F1FE47",
  containerNeutralDarkMediumFixed: "rgba(2, 2, 16, 0.32)",
  containerErrorTransparentLowest: "#DC362E1A",
  containerErrorSolidHigh: "#B02B25",
  containerErrorSolidDefault: "#DC362E",
  containerTertiarySolidLow: "#FAFFE2",
  containerTeritarySolidDefault: "#E2FF49",
  containerQuarternySolidDefault: "#49FFC1",
  containerPrimaryTransparentLow: "rgba(102, 73, 255, 0.2)",
  containerWarningSolidDefault: "#F8D22A",
  containerWarningTransparentLow: "#F8D22A33",
  containerSuccessTransparentLow: "#89DA4433",
  containerSuccessSolidHigh: "rgba(167, 227, 115, 1)",
  containerSuccessSolidLow: "rgba(41, 65, 20, 1)",
  containerSecondarySolidDefault: "rgba(255, 73, 135, 1)",
  containerSecondarySolidLow: "#FFE2EC",
  textNeutralMuted: "rgba(2, 2, 14, 0.58)",
  textNeutralOnPrimaryMuted: "rgba(244, 244, 250, 0.59)",
  textNeutralDefaultInverted: "rgba(255, 255, 255, 0.9)",
  textNeutralDefault: "rgba(2, 2, 7, 0.89)",
  textNeutralOnPrimary: "rgba(255, 255, 255, 0.9)",
  textSecondaryOnSecondary: "rgba(42, 0, 20, 1)",
  textPrimaryOnLow: "rgba(42, 0, 143, 1)",
  textSecondaryOnLow: "#86003E",
  textSuccessfullDefault: "#6EAE36",
  textErrorOnLowest: "#B02B25",
  textSuccessOnLowest: "#6EAE36",
  textErrorOnError: "rgba(66, 16, 14, 1)",
  textSuccessOnSuccess: "rgba(41, 65, 20, 1)",
  textTertiaryOnLow: "#768600",
  textTeritaryOnLow: "#F5FFBF",
  replyMessageBackground: "rgba(241, 241, 254, 0.28)",
};

// Function to get colors based on current theme
export const getColors = () => {
  if (typeof window === "undefined") {
    return lightColors; // Server-side rendering fallback
  }

  const isDark = document.documentElement.classList.contains("dark");
  return isDark ? lightColors : lightColors; // Only light colors for now
};

// React hook to get colors that update when theme changes
export const useColors = () => {
  const [colors, setColors] = React.useState(getColors);

  React.useEffect(() => {
    const updateColors = () => {
      setColors(getColors());
    };

    // Check theme on mount
    updateColors();

    // Listen for theme changes
    const observer = new MutationObserver(updateColors);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    // Also listen for system theme changes
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    mediaQuery.addEventListener("change", updateColors);

    return () => {
      observer.disconnect();
      mediaQuery.removeEventListener("change", updateColors);
    };
  }, []);

  return colors;
};

// Export default colors for backward compatibility (light theme)
export const Colors = lightColors;
